import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import css from './ProjectListBlock.module.scss';

import Button from 'components/Button';
import OnPageEditing from 'components/OnPageEditing';
import ProjectCard from 'components/ProjectCard';
import HighlightedProjectBlock from 'components/HighlightedProjectBlock';
import { THEMES, getThemeClassNames } from 'constants/themes';
import OnScreen from 'components/OnScreen';

const HighlightedProjectBlockType = PropTypes.instanceOf(HighlightedProjectBlock);

function projectPropertiesRemapper(props) {
    return {
        ...props,
        address: props.location
    };
}

const ProjectListBlock = ({
    highlightedProject,
    blockId,
    heading,
    link,
    linkText,
    onScreen,
    projects,
    showExternalUrls,
    theme,
}) => (
    <div
        className={cn(css.block, getThemeClassNames(css, theme))}
        data-block={blockId}
    >
        {heading && (
            <OnPageEditing property="Heading">
                <h2 className={cn("block-title-large", css.heading)}>
                    {heading}
                </h2>
            </OnPageEditing>
        )}

        {highlightedProject && <HighlightedProjectBlock {...highlightedProject} inList={true} />}
        
        <OnPageEditing property="Projects">
            <ul className={css.list}>
                {projects.map((project, index) => (
                    <li key={index} className={cn(css.project, {
                        [css["is-on-screen"]]: onScreen,
                        [css["external"]]: showExternalUrls,
                    })}>
                        <ProjectCard
                            {...projectPropertiesRemapper(project)}
                            useExternalUrl={showExternalUrls}
                        />
                    </li>
                ))}
            </ul>
        </OnPageEditing>
        {(link && linkText) && (
            <OnPageEditing property="LinkToMoreContent">
                <div className={css.button}>
                    <Button secondary href={link} target="_blank" {...{light : theme === THEMES.darkgray}}>
                        {linkText}
                    </Button>
                </div>
            </OnPageEditing>
        )}
    </div>
);

ProjectListBlock.propTypes = {
    highlightedProject: PropTypes.shape({HighlightedProjectBlockType}),
    blockId: PropTypes.number,
    heading: PropTypes.string,
    link: PropTypes.string,
    linkText: PropTypes.string,
    onScreen: PropTypes.bool,
    projects: PropTypes.array.isRequired,
    showExternalUrls: PropTypes.bool.isRequired,
    theme: PropTypes.oneOf(
        Object.keys(THEMES).map(s => THEMES[s])
    ),
};

ProjectListBlock.defaultProps = {
    showExternalUrls: false,
    theme: THEMES.darkgray
};

export default OnScreen(ProjectListBlock);



// WEBPACK FOOTER //
// ./src/components/ProjectListBlock/ProjectListBlock.jsx